module.exports = __webpack_public_path__ + "img/gh_8728e2f6d350_344.1b8111c3.jpg";